<template>
    <div class="Jxxkz">
      <JXXKZ />
    </div>
  </template>
  <script>
  import JXXKZ from "@/components/JXXKZ.vue";
  export default {
    components: { JXXKZ },
    data() {
      return {};
    },
  
    methods: {},
  };
  </script>
  <style lang="scss" scoped>
  .Jxxkz {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #efefef;
    overflow-y: scroll;
  }
  </style>